import { CompaniesStateType, CompanyType } from './types';

import { Pagination } from 'enums';
import { CompaniesActionType } from 'enums/CompaniesActionType';
import { CompaniesActionReturnType } from 'state/actions/companies/types';

const initState: CompaniesStateType = {
  isLoading: false,
  companies: [],
  certainCompany: {} as CompanyType,
  search: '',
  page: Pagination.START_PAGE,
};

export const companiesReducer = (
  // eslint-disable-next-line default-param-last
  state: CompaniesStateType = initState,
  action: CompaniesActionReturnType,
): CompaniesStateType => {
  switch (action.type) {
    case CompaniesActionType.SET_COMPANIES:
      return { ...state, companies: action.companies };
    case CompaniesActionType.SET_COMPANIES_AFTER_SCROLL:
      return { ...state, companies: [...state.companies, ...action.companies] };
    case CompaniesActionType.SET_CERTAIN_COMPANY:
      return { ...state, certainCompany: action.company };
    case CompaniesActionType.SEARCH_COMPANIES:
      return { ...state, search: action.search };
    case CompaniesActionType.SET_COMPANIES_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case CompaniesActionType.SET_COMPANIES_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    default:
      return state;
  }
};
